import React, { useState } from 'react'
import { stringToBoolean } from 'srs.sharedcomponents/lib/esm/utils/helpers'
import ToggleSwitchLabeled from 'srs.sharedcomponents/lib/esm/components/atoms/ToggleSwitchLabeled/ToggleSwitchLabeled'
export interface SearchFormProps {
  searchString: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: (
    event:
      | React.KeyboardEvent<HTMLInputElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void
  productSearchError: boolean
  errMesage: () => string | undefined
  t: (key: string, options?: { ns?: string }) => string
  namespace: string
  minSearchLength?: number // Optional minimum search length prop
}
const isAIToggleSwitchEnable = stringToBoolean(
  process.env.REACT_APP_AI_SEARCH_TOGGLESWITCH_ENABLE,
)

function SearchForm({
  searchString,
  onChange,
  onSubmit,
  productSearchError,
  errMesage,
  t,
  namespace,
  minSearchLength = 0, // Default to 0 if not provided
}: Readonly<SearchFormProps>): JSX.Element {
  const isAISearchType = sessionStorage.getItem('isAISearchType')
  const [toggleValue, setToggleValue] = useState(
    isAISearchType && isAISearchType == 'true',
  )

  const handleSubmit = (
    event:
      | React.KeyboardEvent<HTMLInputElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => {
    if (minSearchLength === 0 || searchString.length >= minSearchLength) {
      onSubmit(event)
    }
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault() // Prevent form submission
      handleSubmit(event)
    }
  }

  const changeSearchTypeValue = () => {
    setToggleValue(!toggleValue)
    sessionStorage.setItem('isAISearchType', (!toggleValue).toString())
  }

  return (
    <form className="form-group m-0 text-right w-full header-select-form">
      <div className={`input-group mb-2 mr-sm-2 hideFocus`}>
        <input
          type="text"
          className={`form-control border-rounded-10 web`}
          id="search"
          name="search"
          value={searchString}
          onChange={onChange}
          onKeyDown={handleKeyDown}
          title={t(`SearchBarPlaceHolder`, { ns: namespace })}
          placeholder={t(`SearchBarPlaceHolder`, { ns: namespace })}
        />
        <div className="invalid-feedback">Please search here</div>
        <div className="header__input-group-append">
          <button
            className="input-group-text "
            id="btnsubmit"
            type="button"
            onClick={handleSubmit}
            disabled={
              minSearchLength > 0 && searchString.length < minSearchLength
            }
            style={
              minSearchLength > 0 && searchString.length < minSearchLength
                ? { border: 'none', boxShadow: 'none' }
                : {}
            }
          >
            <img
              src="/images/Search.svg"
              alt="Search"
              style={{ width: '20px', height: '27px' }}
            />
          </button>
        </div>
      </div>
      <div className="d-flex justify-content-end align-items-center">
        {productSearchError && (
          <label
            id="ProductsearchError"
            className="text-danger mb-0 mr-2"
            style={{ marginRight: '10px' }}
          >
            {errMesage()}
          </label>
        )}
        {isAIToggleSwitchEnable && (
          <ToggleSwitchLabeled
            checked={!!toggleValue}
            onChange={changeSearchTypeValue}
            labelOn="AI Search"
            labelOff="SOLR Search"
            disabled={false}
          />
        )}
      </div>
    </form>
  )
}

export default SearchForm
